document.querySelectorAll('.sub-collection-container').forEach((container) => {
  const enableSlider = container.dataset.enableSlider === 'true';
  if (!enableSlider) return;

  const slider = container.querySelector('.sub-collection-slider');
  const prev = container.querySelector('.slider-arrow.prev');
  const next = container.querySelector('.slider-arrow.next');

  if (!slider || !prev || !next) return;

  const updateArrows = () => {
    const maxScroll = slider.scrollWidth - slider.clientWidth;

    const hidePrev = slider.scrollLeft <= 0;
    const hideNext = slider.scrollLeft >= maxScroll - 1;

    prev.hidden = hidePrev;
    next.hidden = hideNext;

    container.classList.toggle(
      'no-slider-arrows',
      maxScroll <= 0 || (hidePrev && hideNext)
    );
  };

  const slideAmount = () => slider.clientWidth * 0.5;

  prev.addEventListener('click', () => {
    slider.scrollBy({ left: -slideAmount(), behavior: 'smooth' });
  });

  next.addEventListener('click', () => {
    slider.scrollBy({ left: slideAmount(), behavior: 'smooth' });
  });

  slider.addEventListener('scroll', updateArrows);
  window.addEventListener('resize', updateArrows);

  updateArrows();
});
